module.exports = __webpack_public_path__ + "static/img/info_title1.17d43e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_title1.png
// module id = SH61
// module chunks = 4